import {endpoint} from "@/utils/api/Conf";
import {Liturgies} from "@/types/Liturgies";

export const liturgiesRequest = async (authToken: string, locale: string): Promise<Liturgies | false> => {
  try {
    const init: RequestInit = {
      method: "GET",
      headers: {
        'Authorization': `Bearer ${authToken}`,
        "X-Language": locale || "it"
      }
    }
    const response = await fetch(endpoint + `liturgies?page_size=50`, init)
    if (!response.ok) {
      return false
    } else {
      return await response.json();
    }
  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
};
